import api from '../axios'


export default {
    getAll() { return api.get('/articulos') },
    get(id) { return api.get(`/articulos/${id}`) },
    create(payload) {
        return api.post('/articulos', payload, {
            headers: payload instanceof FormData
                ? { 'Content-Type': 'multipart/form-data' }
                : undefined
        });
    },
    update(id, payload) {
        console.log(payload);

        return api.post(`/articulos/${id}`, payload, {
            headers: payload instanceof FormData
                ? { 'Content-Type': 'multipart/form-data' }
                : undefined
        });
    }, delete(id) { return api.delete(`/articulos/${id}`) },
    findByCode(code) {
        return api.get(`/articulos/by-code/${code}`);
    },
    search(query) {
        return api.get(`/articulos/search`, { params: { q: query } });
    },
}